import React from "react";
import { FaWhatsapp, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";

const ContactLeft = () => {
  const socials = [
    { icon: <FaWhatsapp />, link: "https://wa.me/918237234351", name: "WhatsApp" },
    { icon: <FaTwitter />, link: "https://x.com/__TheDeveloper_", name: "Twitter" },
    { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/in/thebideveloper/", name: "LinkedIn" },
    { icon: <FaGithub />, link: "https://github.com/TheBIDeveloper", name: "GitHub" },
  ];

  return (
    <div
      className="
        flex-1
        relative overflow-hidden
        bg-gradient-to-r from-bodyColor to-[#202327]
        p-6 lgl:p-10
        rounded-2xl
        shadow-shadowOne
        flex flex-col
        justify-between
        border border-gray-800
        transition-all duration-300
        hover:-translate-y-1
        hover:shadow-[0_20px_40px_rgba(255,0,79,0.15)]
        hover:border-designColor/40
      "
    >
      {/* Info */}
      <div className="relative flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-gray-200">
          Akshay Kalamkar
        </h3>

        <p className="text-lg text-designColor font-medium">
          Power BI Developer
        </p>

        <p className="text-base text-gray-300 leading-6">
          I am a Power BI Developer specializing in building scalable and high-performance BI solutions. 
          I transform raw data into analytical insights through well-designed dashboards and reports focused 
          on business KPIs and trends. I design optimized data models using SQL, DAX, and Power Query, with an 
          emphasis on data accuracy, efficient relationships, and fast refresh performance. My work enables reliable 
          reporting and supports confident, data-driven decision-making across the organization.
        </p>

        <p className="text-sm text-gray-400">
          Phone:{" "}
          <span className="text-lightText font-medium">
            +91 8237234351
          </span>
        </p>

        <p className="text-sm text-gray-400">
          Email:{" "}
          <span className="text-lightText font-medium">
            akshay.kalamkar03@gmail.com
          </span>
        </p>
      </div>

      {/* Social */}
      <div className="relative flex flex-col gap-4">
        <h2 className="text-sm uppercase font-titleFont tracking-wider text-gray-400">
          Find me in
        </h2>

        <div className="flex gap-4">
          {socials.map((item, idx) => (
            <a
              key={idx}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="
                relative group
                w-12 h-12
                rounded-full
                bg-gradient-to-r from-bodyColor to-[#202327]
                flex items-center justify-center
                text-gray-300
                border border-gray-700
                transition-all duration-300
                hover:border-designColor
                hover:text-designColor
                hover:-translate-y-1
                hover:shadow-[0_8px_20px_rgba(255,0,79,0.2)]
              "
            >
              <span className="transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                {item.icon}
              </span>

              <span
                className="
                  absolute top-full mt-2
                  hidden group-hover:block
                  px-2 py-1
                  text-xs
                  rounded
                  bg-black
                  text-white
                  whitespace-nowrap
                "
              >
                {item.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
